import { render, staticRenderFns } from "./FinanceWallets.vue?vue&type=template&id=758bf740&scoped=true&"
import script from "./FinanceWallets.vue?vue&type=script&lang=js&"
export * from "./FinanceWallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758bf740",
  null
  
)

export default component.exports